export default __webpack_public_path__ + "static/media/ri_linkedin.a502592a.svg";